<ion-content class="ion-padding py-[8px] px-[40px]">
  <div class="py-[8px] px-[40px]">
    <div class="flex flex-col gap-y-[20px] items-center">
      <h3 class="self-center">Share</h3>
      <!-- <div class="w-full">
        <ark-button 
        [type]=" linkCopied ? buttonState : 'secondary'"
        rightIcon="system-copy" class="w-full"
        (click)="copyToClipboard()"
        >
          {{ linkCopied ? ' LINK COPIED' : ' COPY LINK' }}
        </ark-button>
      </div> -->
      <div class="flex justify-center pt-[35px] ">
        <ark-lib-icon-name
          [name]="getIconName('Copy')"
          class="h-full max-h-full"
          (click)="selectIcon('Copy')"
        ></ark-lib-icon-name>
      </div>
      <div class="flex flex-row gap-[10px] h-[90px]pb-[1px]">
         <!-- <ark-lib-icon-name
          [name]="selectedIcon === 'Copy' ? copyIconState : 'copy-inactive'"
          class="h-full max-h-full"
          (click)="selectIcon('Copy')"
        ></ark-lib-icon-name> -->
        <ark-lib-icon-name
          class="h-full max-h-full"
          [name]="getIconName('X')"
          (click)="selectIcon('X')"
        ></ark-lib-icon-name>
        <ark-lib-icon-name
           class="h-full max-h-full"
           [name]="getIconName('Facebook')"
           (click)="selectIcon('Facebook')"
          
        ></ark-lib-icon-name>
        <ark-lib-icon-name
          class="h-full max-h-full"
          [name]="getIconName('LinkedIn')"
          (click)="selectIcon('LinkedIn')"
          
        ></ark-lib-icon-name>
        <ark-lib-icon-name
          *ngIf="!socialOnly"
          class="h-full max-h-full"
          [name]="getIconName('The Solutions Movement')"
          (click)="selectIcon('The Solutions Movement')"
          
        ></ark-lib-icon-name>
        <!-- <ark-lib-icon-name
          name="copy"
          class="h-[48px] w-[48px]"
          (click)="selectIcon('copy')"
          [ngClass]="{
            'border-2 border-black rounded-[5px]': selectedIcon === 'copy'
          }"
        ></ark-lib-icon-name> -->
      </div>
      <!-- <div *ngIf="selectedIcon === 'copy'" class="w-full mt-4 flex flex-col items-center gap-2">
        <input
          [value]="caseShareUrl"
          readonly
          class="w-full p-2 border border-gray-300 rounded text-sm text-gray-800"
        />
        <ark-button (click)="copyToClipboard()" class="w-[130px]">COPY LINK</ark-button>
      </div> -->
      <ark-button
        (click)="selectedIcon === 'Copy' ? copyToClipboard() : share()"
        rightIcon="{{ selectedIcon === 'Copy' ? 'system-copy' : 'system-upload' }}"
        [type]=" 
          linkCopied
          ? buttonState
          : selectedIcon === 'Copy'
          ? 'secondary'
          : 'primary'"
        class="w-full"
        [disabled]="!selectedIcon"
        >
        {{ selectedIcon === 'Copy' ? (linkCopied ? 'LINK COPIED' : 'COPY LINK') : 'SHARE' }}
        </ark-button
      >
      <ark-button type="secondary" class="w-[130px]" (click)="cancel()"
        >
        CANCEL
        </ark-button
      >
    </div>
  </div>
</ion-content>
